import React from "react";

// Circular avatar that supports per-astrologer face focus via
// `imagePosition` (CSS object-position) and `imageZoom` (1.0 = cover).
const Avatar = ({ astrologer, sizeClass = "w-24 h-24", ringClass = "ring-4 ring-slate-100" }) => {
  const zoom = astrologer.imageZoom && astrologer.imageZoom > 0 ? astrologer.imageZoom : 1.0;
  const position = astrologer.imagePosition || "center";
  const bgSize = zoom === 1.0 ? "cover" : `${Math.round(zoom * 100)}%`;

  return (
    <div
      role="img"
      aria-label={astrologer.name}
      className={`${sizeClass} ${ringClass} rounded-full bg-slate-100 bg-no-repeat shrink-0`}
      style={{
        backgroundImage: `url(${astrologer.image})`,
        backgroundPosition: position,
        backgroundSize: bgSize,
      }}
    />
  );
};

export default Avatar;
